export const setClipboard = async (text) => {
    const type = 'text/plain'
    const blob = new Blob([text], { type })
    const data = [new ClipboardItem({ [type]: blob })]
    await navigator.clipboard.write(data)
}

export const deepCopy = (complexObject) => JSON.parse(JSON.stringify(complexObject))

export const randomReactKey = () => Math.floor(Math.random() * 1000000000)

export const shuffleArray = (array) => {
    const newArray = deepCopy(array)
    let currentIndex = array.length

    // While there remain elements to shuffle...
    while (currentIndex !== 0) {

        // Pick a remaining element...
        let randomIndex = Math.floor(Math.random() * currentIndex)
        currentIndex--

        // And swap it with the current element.
        [newArray[currentIndex], newArray[randomIndex]] = [
            newArray[randomIndex], newArray[currentIndex]]
    }

    return newArray
}